<template>
    <div class="section">
        <div class="container is-fluid">
            <div class="columns">
                <div class="column">
                    <h1 class="title has-text-centered">Requests</h1>
                </div>
            </div>
            <div class="columns is-centered">
                <div class="column is-half">
                    <div v-if="successStatus" class="notification is-primary">
                        Request has been send.
                    </div>
                    <div v-if="errorStatus" class="notification is-danger">
                        Request has not been send.
                    </div>
                    <div class="field">
                        <label class="label">Select Client</label>
                        <p class="control is-expanded">
                            <model-select :options="options"
                                          v-model="item"
                                          class="input"
                                          placeholder="Select Client">
                            </model-select>
                        </p>
                    </div>
                    <div class="field">
                        <label class="label">Request</label>
                        <div class="control">
                            <div class="select">
                                <select v-model="type">
                                    <option value="" selected disabled>Select request type</option>
                                    <option>Car transfer</option>
                                    <option>Eliminate car</option>
                                    <option>Eliminate invoice</option>
                                    <option>Approve new price plan</option>
                                    <option>Create new Staff</option>
                                    <option>External source item purchase</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Subject</label>
                        <div class="control">
                            <input class="input" v-model="subject" type="text" placeholder="Type chassis number, price plan id or link." value="bulma">
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Message</label>
                        <div class="control">
                            <textarea v-model="message" class="textarea" placeholder="Textarea"></textarea>
                        </div>
                    </div>
                    <div class="field is-grouped">
                        <div class="control">
                            <button class="button is-link" :class="{'is-loading': isLoading }" @click="submitRequest()">Submit</button>
                        </div>
                        <div class="control">
                            <button class="button is-text" @click="resetForm()">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ModelSelect } from 'vue-search-select'
    import apiUsers from './../../../api/apiUsers'
    import apiRequests from './../../../api/apiRequests'
    export default {
        components: {
            ModelSelect
        },
        data () {
            return {
                isLoading: false,
                errorStatus: false,
                successStatus: false,
                type: '',
                subject: '',
                message: '',
                options: [],
                item: {
                    value: '',
                    text: ''
                }
            }
        },
        methods: {
            setSelectOptions (users) {
                let list = []

                users.forEach(function(element) {
                    list.push({
                        value: element.id,
                        text: element.name
                    })
                })
                this.options = list
            },
            changeStatusSuccess() {
                this.isLoading = false
                this.successStatus = true
﻿               setTimeout(() => {
                    this.successStatus = false;
                }, 5000)
                this.resetForm()
            },
            changeStatusError() {
                this.isLoading = false
                this.errorStatus = true
                setTimeout(() => {
                    this.errorStatus = false;
                }, 5000)
            },
            submitRequest(){
                this.isLoading = true
                let data = {
                    user_id: this.item.value,
                    user_name: this.item.text,
                    type: this.type,
                    subject: this.subject,
                    message: this.message,
                }

                apiRequests
                    .sendRequest(data)
                    .then((response) => {
                        this.changeStatusSuccess()
                    })
                    .catch((error) => {
                        this.changeStatusError()
                        console.log(error)
                    })
            },
            resetForm() {
                this.type= ''
                this.subject= ''
                this.message= ''
                this.item = {
                    value: '',
                    text: ''
                }
            }
        },
        created() {
            apiUsers
                .requestAllUsers()
                .then((response) => {
                    this.setSelectOptions(response.data)
                })
                .catch((error) => {
                    console.log(error)
                })
        }

    }
</script>

<style scoped>
    .title {
        margin-top: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Requests/Requests.vue